module.exports = __webpack_public_path__ + "static/media/logo.d75938b6.png";